import React from "react";
import ReactDOM from "react-dom/client";
import store from "./gStore/Store";
import { AuthProvider } from "./Context/AuthProvider";
import jMoment from "moment-jalaali";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./App.css";
import App from "./App.js";
import { Provider } from "react-redux";
import i18n, { setLanguageLock } from "../src/i18n/index.ts"; // هر دو از یک مسیر
// index.js
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
// import i18n from './i18n';

const root = ReactDOM.createRoot(document.getElementById("root"));

const applyMomentDigits = (lng) => {
  jMoment.loadPersian({
    dialect: "persian-modern",
    usePersianDigits: lng === 'fa', // ← فقط برای فارسی
  });
};

applyMomentDigits(i18n.language);

i18n.on("languageChanged", (lng) => {
  document.dir = i18n.dir(lng);
  document.documentElement.lang = lng;
  applyMomentDigits(lng); // ← دوباره تنظیم میشه با تغییر زبان
});
// قفل کردن زبان اگه کاربر از قبل لاگینه
const token = localStorage.getItem("claims");
if (token) {
  setLanguageLock(true);
}

// ست اولیه‌ی جهت و زبان
document.dir = i18n.dir();
document.documentElement.lang = i18n.language;

// فقط یک بار subscribe میشه
i18n.on("languageChanged", (lng) => {
  document.dir = i18n.dir(lng);
  document.documentElement.lang = lng;
});


root.render(
  <AuthProvider>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </AuthProvider>
);